/**
 * Created by Daniil Vat. on 18/2/2021
 * Copyright © 2021 Curriculum Ltd. All rights reserved.
 */

import {Component, Input, OnInit, OnChanges, SimpleChanges, Output, EventEmitter} from '@angular/core';
import { trigger, transition, style, animate } from '@angular/animations';

@Component({
  selector: 'curr-expansion-panel',
  templateUrl: './expansion-panel.component.html',
  styleUrls: ['./expansion-panel.component.scss'],
  animations: [
    trigger('enterAnimation', [
      transition(':enter', [style({ opacity: 0 }), animate('200ms', style({ opacity: 1 }))]),
      transition(':leave', [style({ opacity: 1 }), animate('200ms', style({ opacity: 0 }))])
    ])
  ]
})
export class ExpansionPanelComponent implements OnInit, OnChanges {
  @Input() title: string;
  @Input() subTitle: string;
  @Input() isDisabled? = false;
  @Input() isShowed = true;
  @Input() isAbsentLogic = false;
  @Input() isAbsent = false;
  @Input() isAbsentBtnShow = false;
  @Input() status: 'approved' | 'pending' | 'ai_processing' | 'system_processing';
  @Output() absentBtnClick = new EventEmitter();

  isError = false;
  inEditMode = false;
  statusText: string;

  constructor() {}

  get statusClass() {
    if (this.status === 'approved') {
      return 'approved';
    } else if (this.status === 'ai_processing') {
      return 'ai-processing';
    } else if (this.status === 'system_processing') {
      return 'system-processing';
    } else {
      return 'pending';
    }
  }

  ngOnInit() {
    this.statusText = this.status;
    if (this.status === 'ai_processing') {
      this.statusText = 'AI Processing';
    }
    if (this.status === 'system_processing') {
      this.statusText = 'System Processing';
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['status']) {
      this.statusText = changes['status'].currentValue;
      if (changes['status'].currentValue === 'ai_processing') {
        this.statusText = 'AI Processing';
      }
      if (changes['status'].currentValue === 'system_processing') {
        this.statusText = 'System Processing';
      }
    }
  }

  toggleDropdown() {
    if (!this.isDisabled) {
      this.isShowed = !this.isShowed;
    }
  }

  closeDropDown() {
    this.isShowed = false;
  }

  absentBtnAction(event) {
    event.stopPropagation()
    event.preventDefault();
    this.absentBtnClick.emit();
  }
}
